/** @format */

import React, { ReactNode } from "react";
import styled from "styled-components";
import { colors, mixins } from "../../../../css/variables";
import { EmochiEntryContentsMerchant } from "./EntryContents/EntryContentsMerchant";
import { EmochiEntryContentsBankAccount } from "./EntryContents/EntryContentsBankAccount";
import { EmochiEntryContentsShop } from "./EntryContents/EntryContentsShop";
import { EmochiEntrySide } from "./EntrySide";

const EntryColumnStyle = styled.div`
  display: flex;
  ${mixins.screenOver()} {
    gap: 32px;
  }
  ${mixins.screenUnder()} {
    flex-direction: column;
  }
  & > main {
    flex: 1;
    background: ${colors.themeColor("background_main")};
    border-radius: 8px;
    border: 1px solid ${colors.themeColor("border_box")};
    ${mixins.screenOver()} {
      padding: 36px;
    }
    ${mixins.screenUnder()} {
      padding: 28px 16px;
    }
  }
  & > div:last-child {
    ${mixins.screenOver()} {
      width: 270px;
    }
  }
`;

export const EmochiEntryColumn = ({ path, redirect = false }: { path: string; redirect?: boolean }) => {
  let showPage: ReactNode = <></>;
  switch (path) {
    case "merchant":
      showPage = <EmochiEntryContentsMerchant />;
      break;
    case "bank_account":
      showPage = <EmochiEntryContentsBankAccount />;
      break;
    case "shop":
      showPage = <EmochiEntryContentsShop />;
      break;
    default:
      showPage = "表示する内容がありません";
  }
  return (
    <EntryColumnStyle>
      <main>{showPage}</main>
      <div>
        <EmochiEntrySide path={path} redirect={redirect} />
      </div>
    </EntryColumnStyle>
  );
};
